import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Colleen B.',
    headline: 'went for a checkup, and her periodontist was shocked!',
    quote: "I was skeptical, but after 8 weeks, my periodontist commented on how much healthier my gums looked. I hadn't even told him I was using it."
  }, {
    name: 'Carolyn S.',
    headline: 'saved $900 because she didn’t need a cleaning anymore…',
    quote: "My dentist is very impressed with reduced plaque and general health. I don't even need a cleaning as there was nothing to remove. Finally! Something I buy online actually does what it claims."
  }, {
    name: 'Maureen L.',
    headline: 'was feeling hopeless about her teeth and smile…',
    quote: "It took a lot of energy to hide my teeth and it's very liberating to smile freely! I stand taller and my face and neck are more relaxed."
  }, {
    name: 'Barbara P.',
    headline: 'thought she would be doomed with cavities forever…',
    quote: 'Went from having a cavity or two every dentist visit to not having a cavity in almost 2 years.'
  }];
  return <section className="py-8 mb-12" data-id="element-513">
      <div className="max-w-3xl mx-auto px-4" data-id="element-514">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-515">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-516">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col" data-id="element-517">
                <div className="flex text-yellow-400 mb-3" data-id="element-518">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-519" />)}
                </div>
                <p className="font-sans font-semibold text-gray-900 mb-3 text-sm leading-snug" data-id="element-520">
                  <span className="text-teal-700" data-id="element-521">{t.name}</span> {t.headline}
                </p>
                <p className="text-gray-600 italic text-sm flex-grow" data-id="element-522">
                  "{t.quote}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}